import { getInitials } from '@/utils/format';

interface ProviderAvatarProps {
  firstName: string;
  lastName: string;
  photoUrl: string | null;
  size?: 'sm' | 'lg';
}

const sizeClasses = {
  sm: 'h-10 w-10 text-xs',
  lg: 'h-16 w-16 text-sm',
};

export function ProviderAvatar({ firstName, lastName, photoUrl, size = 'sm' }: ProviderAvatarProps) {
  const name = `${firstName} ${lastName}`;

  if (photoUrl) {
    return (
      <img
        alt={name}
        className={`${sizeClasses[size]} rounded-full border border-neutral-100 object-cover`}
        src={photoUrl}
      />
    );
  }

  return (
    <div
      className={`${sizeClasses[size]} flex items-center justify-center rounded-full bg-neutral-100 font-medium text-neutral-600`}
    >
      {getInitials(firstName, lastName)}
    </div>
  );
}
